var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"has-text-weight-bold has-text-info",on:{"click":function($event){$event.preventDefault();return _vm.downloadAs.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.getLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }